import React, { createContext, useContext, useState, useEffect } from "react";
import { db } from "../firebase/firebase";
import { doc, onSnapshot } from "firebase/firestore";

// Context create karo
const SaleCountdownContext = createContext();

// Context Provider function
export const SaleCountdownProvider = ({ children }) => {
  // Local Storage se initial data load kar lo
  const [saleStartTime, setSaleStartTime] = useState(
    localStorage.getItem("saleStartTime") ? parseInt(localStorage.getItem("saleStartTime")) : null
  );  
  const [saleEndTime, setSaleEndTime] = useState(
    localStorage.getItem("saleEndTime") ? parseInt(localStorage.getItem("saleEndTime")) : null
  );
  const [saleMessage, setSaleMessage] = useState(
    localStorage.getItem("saleMessage") || "⏳ Hurry up! Sale Ends In"
  );
  const [saleButtonName, setSaleButtonName] = useState(
    localStorage.getItem("saleButtonName") || "🛒 Shop Now"
  );
  const [saleLink, setSaleLink] = useState(
    localStorage.getItem("saleLink") || "/shop"  // saleLink from database
  );

  useEffect(() => {
    const saleRef = doc(db, "sales", "saleCountdown");

    const unsubscribe = onSnapshot(saleRef, (doc) => {
      if (doc.exists()) {
        const data = doc.data();
        const startTime = data.saleStartTime.toDate().getTime(); // Fetch start time
        const endTime = data.saleEndTime.toDate().getTime();
        const message = data.saleMessage || "⏳ Hurry up! Sale Ends In";
        const buttonName = data.saleButtonName || "🛒 Shop Now" // Fetch button name
        const link = data.saleLink; // Fetch saleLink from database

        setSaleStartTime(startTime);
        setSaleEndTime(endTime);
        setSaleMessage(message);
        setSaleButtonName(buttonName);
        setSaleLink(link); // Set saleLink

        // Save to Local Storage
        localStorage.setItem("saleStartTime", startTime.toString());
        localStorage.setItem("saleEndTime", endTime.toString());
        localStorage.setItem("saleMessage", message);
        localStorage.setItem("saleButtonName", buttonName);
        localStorage.setItem("saleLink", link); // Save saleLink to localStorage
      }
    });

    return () => unsubscribe();
  }, []);
  

  return (
    <SaleCountdownContext.Provider value={{ saleStartTime, saleEndTime, saleMessage, saleButtonName, saleLink }}>
      {children}
    </SaleCountdownContext.Provider>
  );
};

// Custom hook to use context
export const useSaleCountdown = () => useContext(SaleCountdownContext);
